import React, { useState } from 'react'
import { projectsData, projectNav } from './Data'
import WorkItems from './WorkItems'

const Works = () => {
    const [active, setActive] = useState('all');

    const projects = active === 'all'
        ? projectsData
        : projectsData.filter((project) => project.category.toLowerCase() === active);

  return (
    <div>
        <div className="work__filters" role="tablist" aria-label="Filter projects by category">
            {projectNav.map((item) => (
                <button
                    type="button"
                    role="tab"
                    aria-selected={active === item.name}
                    onClick={() => setActive(item.name)}
                    className={`${active === item.name ? 'active-work' : ''} work__item`}
                    key={item.name}
                >
                    {item.name}
                </button>
            ))}
        </div>

        <div className="work__container container grid">
            {projects.map((item) => (
                <WorkItems item={item} key={item.id} />
            ))}
        </div>
    </div>
  )
}

export default Works;
